export default __webpack_public_path__ + "static/media/about.7cbe4db2.svg";